import React from 'react';
import { getAppUrl } from '@nova-integration/ui-shared';
import { APP_ID } from '../lib/capabilities';

export const UsersPage: React.FC = () => {
  const identityUrl = getAppUrl('identity', APP_ID);
  const adminUrl = identityUrl ? `${identityUrl}/admin-ui/` : '';

  return (
    <div className="space-y-8">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">User Accounts</h1>
        <p className="text-sm text-gray-500 mt-1">
          User management has moved to the central <strong>Identity Service</strong>. Users, roles, and
          per-app grants are managed from a single place across all Nova integration apps.
        </p>
      </div>

      <div className="bg-white rounded-xl border border-gray-200 p-8">
        <h2 className="text-lg font-semibold text-gray-900 mb-2">Open Identity Admin</h2>
        <p className="text-sm text-gray-600 mb-6">
          The Identity admin UI lets you create users, assign per-app roles (ops, diaper, identity), and
          inspect the authentication audit log.
        </p>
        {adminUrl ? (
          <>
            <a
              href={adminUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block px-4 py-2 bg-[#1D407B] text-white text-sm font-medium rounded-lg hover:bg-[#162f5a] transition-colors"
            >
              Open Identity Admin →
            </a>
            <p className="text-xs text-gray-400 mt-4">{adminUrl}</p>
          </>
        ) : (
          <p className="text-sm text-amber-700 bg-amber-50 border border-amber-200 rounded-lg p-3">
            Identity URL is not configured. Set <code>IDENTITY_PUBLIC_URL</code> on the Ops UI pod (or
            <code> REACT_APP_IDENTITY_URL</code> in dev) and reload.
          </p>
        )}
      </div>
    </div>
  );
};
